// extracted by mini-css-extract-plugin
module.exports = {"quote":"Quote_quote__ZJlwe","avatar":"Quote_avatar__k1rF7","name":"Quote_name__SuFHc","description":"Quote_description__dVRbu"};